import { apiRequest } from "../../apiCall";



export const getLatestCustomerCallsRequest = () => apiRequest('Dashboard.GetLatestCustomerCalls')
